module.exports = __webpack_public_path__ + "4303b4f40623c7fde8967b33edf1b9f2.pdf";